import { useMutation } from "@apollo/client";
import {
  AddOrderProductDocument,
  type CreateProductInput,
  GetOrderByIdDocument,
} from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export type { CreateProductInput } from "../../gql/generated/graphql";

export const useAddOrderProduct = ({ orderId }: Props) => {
  const [addOrderProduct, { loading }] = useMutation(AddOrderProductDocument, {
    refetchQueries: [GetOrderByIdDocument],
    awaitRefetchQueries: true,
  });

  return {
    addOrderProduct: (product: CreateProductInput) =>
      addOrderProduct({
        variables: { orderId, product },
      }),
    loading,
  };
};
